import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

type useIntersectProps = {
    root?: HTMLElement | null;
    rootMargin?: string;
    threshold?: number;
};

export const useIntersect = ({
    root = null,
    rootMargin = '0px',
    threshold = 0,
}: useIntersectProps): {
    entry: IntersectionObserverEntry;
    referencer: Dispatch<SetStateAction<HTMLDivElement | null>>;
} => {
    const [entry, setEntry] = useState({} as IntersectionObserverEntry);
    const [node, setNode] = useState<HTMLDivElement | null>(null);

    const observer = useRef(
        new window.IntersectionObserver(([value]) => setEntry(value), {
            root,
            rootMargin,
            threshold,
        })
    );

    useEffect(() => {
        const { current: currentObserver } = observer;
        currentObserver.disconnect();

        if (node) currentObserver.observe(node);

        return () => currentObserver.disconnect();
    }, [node]);

    return {
        referencer: setNode,
        entry,
    };
};
